export default {
    title: 'Create organisation',
    name: 'Name',
    createOrganisation: 'Create organisation',
    createOrganisationSuccess: 'The organisation has been created successfully.',
    createOrganisationError: 'An error occurred while creating the organisation.'
}